import type { JSX } from 'react';

import {
  coreExtensionData,
  createExtensionBlueprint,
  ExtensionBoundary,
} from '@backstage/frontend-plugin-api';

export const HeaderComponentBlueprint = createExtensionBlueprint({
  attachTo: { id: 'app/layout', input: 'headerComponents' },
  * factory(
    params: {
      loader: () => Promise<JSX.Element>;
      order?: number;
    },
    { node },
  ) {
    yield coreExtensionData.reactElement(
      ExtensionBoundary.lazy(node, params.loader),
    );
  },
  kind: 'header-component',
  output: [coreExtensionData.reactElement],
});
